if (!customElements.get('cart-drawer-upsell')) {
  class CartDrawerUpsell extends HTMLElement {
    constructor() {
      super();

      this.isLoading = false;
      this.loadedProductId = null;
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.cartDrawer = this.closest('cart-drawer');

      if (!this.cartDrawer) return;

      this.addEventListener('click', this.handleClick);

      this.drawerObserver = new MutationObserver(() => {
        this.loadWhenOpen();
      });

      this.drawerObserver.observe(this.cartDrawer, {
        attributes: true,
        attributeFilter: ['class'],
      });

      this.loadWhenOpen();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);

      if (this.drawerObserver) {
        this.drawerObserver.disconnect();
      }
    }

    loadWhenOpen() {
      if (!this.cartDrawer.classList.contains('active')) return;

      const productId = this.dataset.productId;

      if (!productId) return;
      if (this.isLoading) return;
      if (this.loadedProductId === productId) return;

      this.loadRecommendations(productId);
    }

    async loadRecommendations(productId) {
      this.isLoading = true;

      const root = window.Shopify?.routes?.root || '/';
      const url =
        `${root}recommendations/products` +
        `?section_id=cart-drawer-upsell` +
        `&product_id=${encodeURIComponent(productId)}` +
        `&limit=6` +
        `&intent=complementary`;

      try {
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`Recommendations request failed: ${response.status}`);
        }

        const text = await response.text();
        const documentFragment = new DOMParser().parseFromString(text, 'text/html');
        const content = documentFragment.querySelector(
          '[data-cart-drawer-upsell-content]'
        );

        this.loadedProductId = productId;

        if (!content || !content.innerHTML.trim()) {
          this.hidden = true;
          return;
        }

        this.innerHTML = content.innerHTML;
        this.hidden = false;
      } catch (error) {
        this.hidden = true;
        console.warn('Cart drawer recommendations could not be loaded.', error);
      } finally {
        this.isLoading = false;
      }
    }

    async handleClick(event) {
      const button = event.target.closest('[data-upsell-add]');

      if (!button || !this.contains(button)) return;

      const variantId = button.dataset.variantId;

      if (!variantId || button.disabled) return;

      const originalText = button.textContent;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding...';

      try {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        const sections = this.cartDrawer
          .getSectionsToRender()
          .map((section) => section.id);

        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);

        if (typeof this.cartDrawer.setActiveElement === 'function') {
          this.cartDrawer.setActiveElement(button);
        }

        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(result.description || 'Unable to add this product.');
        }

        this.cartDrawer.renderContents(result);
      } catch (error) {
        const errorContainer = document.querySelector('#CartDrawer-CartErrors');

        if (errorContainer) {
          errorContainer.textContent =
            error.message || 'Unable to add this product. Please try again.';
        }

        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = originalText;

        console.warn('Complementary product could not be added.', error);
      }
    }
  }

  customElements.define('cart-drawer-upsell', CartDrawerUpsell);
}